import React from 'react';

const AimIcon = (props) => (
  <svg {...props} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='-0.65 -0.65 25.38 24.55'>
    <circle cx='12.0382' cy='11.208' r='7.2371' stroke={props.fill} strokeWidth='1.3' />
    <line x1='12.273' x2='12.273' y2='8.30221' stroke={props.fill} strokeWidth='1.3' />
    <line x1='12.273' y1='14.944' x2='12.273' y2='23.2462' stroke={props.fill} strokeWidth='1.3' />
    <line x1='24.0764' y1='11.4429' x2='14.944' y2='11.4429' stroke={props.fill} strokeWidth='1.3' />
    <line x1='9.13232' y1='11.4429' x2='-0.000105858' y2='11.4429' stroke={props.fill} strokeWidth='1.3' />
  </svg>
);

export default AimIcon;
